export const MARKETING_LEAD_MEDIUM = "Direct";

export const MARKETING_LEAD_SOURCE = "EC Walk-in";

export const MARKETING_LEAD_SOURCE_RFFERAL = "EC WalkIn Referral";

/* eslint-disable-next-line */
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const projectIdRegex = /^[1-9][0-9]*$/;

export const ACTIONS = {
  deposited: "Mark Deposited",
  collected: "Mark Collected",
};
